export default "__VITE_ASSET__VzIdz1QT__"